import React from 'react';
import PropTypes from 'prop-types';
import AmountAndTotalField from 'components/field/AmountAndTotalField';
import BookingStatsGraph from 'pages/bookingStats/list/BookingStatsGraph';
import BookingStatsListFilters from 'pages/bookingStats/list/BookingStatsListFilters';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import compose from 'recompose/compose';
import listQueryFilter from 'components/hoc/listQueryFilter';
import theme from 'theme/theme';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchBookingStats } from 'store/actions/bookingStats/fetchBookingStats';
import { formValueSelector } from 'redux-form';

class BookingStatsList extends React.Component {
    constructor(props, context) {
        super(props, context);

        const {
            config: {
                currency: {
                    system,
                },
            },
        } = context;

        this.system = system;
    }

    reorderSystemCurrency = (currencies) => {
        if (utils.isUndefined(currencies) || utils.isEmpty(currencies)) {
            return [];
        }

        if (utils.isUndefined(currencies[0])) {
            return [];
        }

        if (~currencies.indexOf(this.system)) {
            currencies.splice(currencies.indexOf(this.system), 1);
            currencies.unshift(this.system);
        }

        return currencies;
    }

    render() {
        const {
            actionType,
            currencies,
            data,
            interval,
            location,
            resource,
            updateQuery,
        } = this.props;

        const selected = this.reorderSystemCurrency(currencies);

        return (
            <div>
                <BookingStatsListFilters
                    actionType={ actionType }
                    location={ location }
                    resource={ resource }
                    updateQuery={ updateQuery }
                />

                { !utils.isEmpty(data) &&
                    <BookingStatsGraph
                        interval={ interval }
                        rawData={ data }
                        selected={ selected }
                    />
                }

                <ResourceList
                    action={ fetchBookingStats }
                    actionType={ actionType }
                    location={ location }
                    resource={ resource }
                    updateQuery={ updateQuery }
                >
                    <Table
                        colorToggle={ {
                            condition: false,
                            color: theme.palette.gray,
                            key: 'enabled',
                        } }
                    >
                        <TextField
                            label='resources.bookingStats.fields.label'
                            source='label'
                            column={ {
                                link: false,
                                sortable: false,
                                width: '30%',
                            } }
                        />

                        {
                            selected.map(function (currency) {
                                return <AmountAndTotalField
                                    key={ currency }
                                    label={ `resources.bookingStats.fields.${ currency }` }
                                    sortable={ false }
                                    source={ currency }
                                    column={ {
                                        link: false,
                                        sortable: false,
                                        width: '30%',
                                    } }
                                />;
                            })
                        }
                    </Table>
                </ResourceList>
            </div>
        );
    }
}

BookingStatsList.contextTypes = {
    config: PropTypes.object,
};

BookingStatsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    currencies: PropTypes.array,
    data: PropTypes.object,
    interval: PropTypes.string,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

const selector = formValueSelector('filterForm');

const mapStateToProps = (state, props) => {
    const {
        resource,
    } = props;

    const getCurrencies = selector(state, 'currencies');
    let currencies = undefined;

    if (getCurrencies) {
        currencies = getCurrencies.value;
    }

    const getInterval = selector(state, 'interval');
    let interval = undefined;

    if (getInterval) {
        interval = getInterval.value;
    }

    const stateResource = state[resource];

    return {
        currencies: currencies,
        interval: interval,
        data: utils.reverse(stateResource.data),
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        null,
    ),
    listQueryFilter,
);

export default enhance(BookingStatsList);



// WEBPACK FOOTER //
// ./src/pages/bookingStats/list/BookingStatsList.js